export default function Politica() {
    return (
        <div>
            <div id="politica" className="w-full bg-white p-6 md:p-24">
                <div className="justify-center align-middle font-roboto text-xs md:text-lg font-normal text-justify text-[#666666] leading-[22px] md:leading-[33px] md:mx-24 space-y-6">
                    <div>
                        A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        , inscrita no CNPJ sob o n°{" "}
                        <strong>26.390.648/0001-05</strong>, com sede
                        <strong>
                            na Rua Claudio da Silva Pinto nº 770 – Porto Alegre
                            - RS
                        </strong>
                        , tem como compromisso o respeito pela privacidade de
                        seus usuários, bem como a proteção e a segurança dos
                        seus dados pessoais.
                    </div>

                    <div>
                        A presente Política de Privacidade (“Política de
                        Privacidade Projectiva”) tem como objetivo esclarecer
                        quais informações são coletadas dos usuários de nossos
                        sites e respectivas soluções e serviços (“Soluções” e
                        “Serviços”) – e de que forma esses dados são tratados.
                    </div>

                    <div>
                        Para oferecer os Soluções e Serviços aos seus clientes,
                        a{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        , por meio de seus sites, coleta diversos dados e
                        informações, visando, sobretudo, proporcionar uma
                        experiência cada vez melhor para você.
                    </div>

                    <div>
                        A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda{" "}
                        </strong>
                        reconhece que a sua privacidade é muito importante,
                        portanto tomamos todas as medidas possíveis, dentro das
                        melhores práticas e soluções existentes, para
                        protegê-la. Nesse sentido, a presente Política visa
                        informá-lo como os seus dados pessoais serão tratados.
                    </div>

                    <div>
                        Este documento é parte integrante do Termo e Condições
                        de Uso, que contém informações sobre o uso, isenções e
                        limitações de responsabilidade com relação à utilização
                        dos sites e aplicativos da{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        .
                    </div>

                    <div>
                        Essa Política foi redigida de forma simples e acessível,
                        justamente para que você possa ler e entender como
                        utilizamos os seus dados para proporcionar uma
                        experiência segura e confortável no uso das Soluções e
                        Serviços ofertados.
                    </div>

                    <div>
                        O aceite dessa Política será considerado formalizado no
                        momento em que você inserir as suas informações ou se
                        cadastrar em nossos sites, para usufruir de materiais,
                        soluções e serviços ofertados pela{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        , mesmo que de forma gratuita.
                    </div>

                    <div>
                        Isso indicará que você está ciente e em total acordo com
                        a forma como utilizaremos as suas informações e seus
                        dados.
                    </div>

                    <div>
                        Caso não concorde com essa Política, por favor, não
                        continue o seu procedimento de cadastro, para a
                        solicitação das Soluções e Serviços fornecidos ou
                        prestados pela{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        . Todavia, pedimos a gentileza de informar à{" "}
                        <strong>DCEG</strong> acerca da sua eventual
                        discordância para que possamos utilizar seus fundamentos
                        para avaliar a revisão dessa Política.
                    </div>

                    <div>
                        A presente Política está dividida da seguinte forma para
                        facilitar a sua compreensão:
                    </div>

                    <div>
                        POLÍTICA DE PRIVACIDADE (WEBSITE)
                        <br />
                        1. INFORMAÇÕES QUE SÃO COLETADAS
                        <br />
                        2. PARA QUE USAMOS SUAS INFORMAÇÕES
                        <br />
                        3. SOBRE O ACESSO AOS SEUS DADOS PESSOAIS
                        <br />
                        4. SOBRE O COMPARTILHAMENTO DE DADOS
                        <br />
                        5. MEDIDAS DE SEGURANÇA
                        <br />
                        6. SEUS DIREITOS
                        <br />
                        7. ALTERAÇÃO/EXCLUSÃO DE DADOS PESSOAIS
                        <br />
                        8. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE
                        <br />
                        9. RECLAMAÇÕES
                    </div>

                    <div>
                        Qualquer dúvida em relação à presente Política poderá
                        ser esclarecida entrando em contato conosco, por meio do
                        endereço eletrônico{" "}
                        <strong>
                            administrativo@projectivatecnologia.com.br
                        </strong>{" "}
                        indicando como assunto “Privacidade de dados pessoais”.
                    </div>

                    <div>1. INFORMAÇÕES QUE SÃO COLETADAS</div>

                    <div>
                        Informações fornecidas por você – Das informações
                        fornecidas por você com o preenchimento dos formulários
                        disponíveis em nossos sites e aplicativos, a{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        coletará aquelas de identificação pessoal, como por
                        exemplo, nome, telefone, e-mail, data de nascimento e
                        CPF.
                    </div>

                    <div>
                        Informações de navegação no site – Quando você acessa
                        nossos sites e aplicativos, poderá ser instalado um
                        ‘cookie’ no seu navegador para identificar quantas vezes
                        você retorna ao nosso endereço. Nesta hipótese, poderão
                        ser coletadas informações como endereço IP, localização
                        geográfica, fonte de referência, tipo de navegador,
                        duração da visita e páginas visitadas. Para maiores
                        informações acesse a nossa Política de Cookies.
                    </div>

                    <div>
                        Histórico de contato – a{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        armazena informações a respeito de todos os contatos
                        (nome completo, e-mail e telefone) já realizados com
                        nossos usuários, como interações pessoais, eletrônicas
                        ou via telefone.
                    </div>

                    <div>
                        Dados gerados pela utilização de nossos Serviços ou
                        solicitação de nossas soluções – Se você utilizar algum
                        de nossos Serviços, ou solicitar nossas soluções, a{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        poderá coletar outras informações necessárias para a
                        execução do contrato de prestação de Serviço ou
                        fornecimento da Solução. Nesse caso, poderão ser
                        coletados dados de contato como seu nome completo,
                        e-mail e telefone, RG, dados locacionais como país,
                        cidade e estado, logradouro, número do logradouro e
                        complemento.
                    </div>

                    <div>2. PARA QUE USAMOS SUAS INFORMAÇÕES</div>

                    <div>
                        Todos os dados coletados são utilizados para a prestação
                        de Serviços ou fornecimento de soluções, tendo a sua
                        privacidade respeitada. Por isso, todos os dados e
                        informações sobre você serão tratados como confidenciais
                        e somente utilizados para os fins aqui descritos e
                        autorizados por você, principalmente, para que possa
                        utilizar nossos Serviços e Soluções de forma plena,
                        visando sempre melhorar a sua experiência como usuário.
                    </div>

                    <div>
                        Dessa forma, poderemos personalizar o serviço ou solução
                        para adequá-los, cada vez mais, às suas preferências e
                        interesses. Ademais, seus dados também poderão ser
                        utilizados para criarmos e oferecermos novos serviços,
                        soluções e funcionalidades, bem como para testarmos as
                        qualidades desses.
                    </div>

                    <div>
                        Dessa forma, poderemos personalizar o serviço ou solução
                        para adequá-los, cada vez mais, às suas preferências e
                        interesses. Ademais, seus dados também poderão ser
                        utilizados para criarmos e oferecermos novos serviços,
                        soluções e funcionalidades, bem como para testarmos as
                        qualidades desses.
                    </div>

                    <div>
                        Eventualmente, poderemos utilizar dados para finalidades
                        não previstas nesta Política, mas que estejam dentro das
                        suas legítimas expectativas. Neste caso, o uso dos seus
                        dados para finalidades que não cumpram com essa
                        prerrogativa será feito mediante autorização que
                        solicitaremos previamente.
                    </div>

                    <div>
                        Além das hipóteses citadas nesta Política, seus dados
                        poderão ser utilizados para as seguintes finalidades:
                    </div>

                    <div>
                        <div className="grid grid-cols-3 text-center border border-gray-300">
                            <div className="border bg-blue-600 text-white border-gray-300 p-2">
                                FINALIDADE DE COLETA
                            </div>
                            <div className="border bg-blue-600 text-white border-gray-300 p-2">
                                CATEGORIA DE DADOS PESSOAIS
                            </div>
                            <div className="border bg-blue-600 text-white border-gray-300 p-2">
                                BASE LEGAL
                            </div>
                        </div>
                        <div className="grid grid-cols-3 text-center border border-gray-300">
                            <div className="border border-gray-300 p-2">
                                Cumprimento de contrato de
                                <br />
                                <span className="font-bold">
                                    segmento da empresa
                                </span>
                            </div>
                            <div className="border border-gray-300 p-2">
                                Dado Pessoal
                            </div>
                            <div className="border border-gray-300 p-2">
                                Art. 7, inciso V da Lei
                                <br />
                                nº13.709/2018
                            </div>
                        </div>
                    </div>

                    <div>3. SOBRE O ACESSO AOS SEUS DADOS PESSOAIS</div>

                    <div>
                        Sem prejuízo do item 4 (abaixo), o acesso às suas
                        informações pessoais estará restrito apenas aos
                        colaboradores da{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        e, dentre estes, somente as pessoas com as autorizações
                        internas específicas para tanto. Eventualmente, caso a
                        inserção de suas informações se dê em ações criadas em
                        parcerias, os parceiros também terão acesso à
                        informação. Exceto se, de outra forma for previsto em
                        Lei, nenhum dado pessoal poderá ser divulgado
                        publicamente sem a sua prévia e expressa autorização.
                    </div>

                    <div>
                        Todos os seus dados são confidenciais e qualquer uso de
                        tais dados estará de acordo com a Lei e com a presente
                        Política. A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        empreenderá todos os esforços razoáveis de mercado para
                        garantir a segurança dos nossos sistemas e,
                        consequentemente, dos seus dados pessoais.
                    </div>

                    <div>
                        Todas as suas informações serão, sempre que possível,
                        criptografadas, caso não inviabilizem o seu uso pela
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        .
                    </div>

                    <div>
                        Dentre outros direitos previstos em Lei, mediante
                        requisição e a qualquer momento, você poderá ter acesso
                        aos seus dados pessoais armazenados em nossos sistemas.
                    </div>

                    <div>
                        A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda{" "}
                        </strong>
                        manterá os seus dados pessoais e informações somente até
                        quando estes forem necessários; ou relevantes para as
                        finalidades descritas nessa Política ou em caso de
                        períodos pré-determinados por Lei; ou até quando estas
                        forem necessárias para a manutenção de interesses
                        legítimos da empresa, nos termos da Lei.
                    </div>

                    <div>4. SOBRE O COMPARTILHAMENTO DE DADOS</div>

                    <div>
                        A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda{" "}
                        </strong>
                        poderá compartilhar os seus dados pessoais, inclusive,
                        compartilhamento internacional, com clientes/parceiros
                        ou terceiros, conforme for razoavelmente necessário para
                        os propósitos estabelecidos na presente Política e para
                        a devida prestação de nossos serviços.
                    </div>

                    <div>
                        Todos os dados, informações e conteúdos sobre você podem
                        ser compartilhados com terceiros, quando e na medida do
                        estritamente necessário, no caso de negociações em que a{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        fizer parte.
                    </div>

                    <div>
                        A{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>{" "}
                        se reserva no direito de fornecer seus dados e
                        informações sobre você, incluindo interações suas, caso
                        seja requisitado judicialmente para tanto, ato
                        necessário para que a empresa esteja em conformidade com
                        as leis nacionais, ou caso nos autorize expressamente.
                    </div>

                    <div>5. MEDIDAS DE SEGURANÇA</div>

                    <div>
                        Para garantir a proteção dos seus dados, utilizamos
                        medidas de segurança técnicas e administrativas a fim de
                        evitar acessos não autorizados e situações acidentais
                        e/ou ilícitas de manipulação, perda, destruição e/ou
                        alteração dos referidos dados.
                    </div>

                    <div>
                        As medidas de segurança são melhoradas e adaptadas
                        continuamente, conforme a atualização da tecnologia
                        aplicável, bem como são observadas as melhores práticas
                        de mercado neste sentido.
                    </div>

                    <div>
                        Todas as suas informações serão, sempre que possível,
                        criptografadas, caso não inviabilizem o seu uso para as
                        finalidades aqui previstas.
                    </div>

                    <div>6. SEUS DIREITOS</div>

                    <div>
                        Você poderá exercer seus direitos acerca dos dados
                        pessoais tratados por nós, sendo estes:
                    </div>

                    <div>
                        I. confirmação da existência de tratamento;
                        <br />
                        II. acesso aos dados;
                        <br />
                        III. correção de dados incompletos, inexatos ou
                        desatualizados;
                        <br />
                        IV. anonimização, bloqueio ou eliminação de dados
                        desnecessários, excessivos;
                        <br />
                        V. portabilidade dos dados a outro fornecedor de serviço
                        ou solução, mediante requisição expressa, de acordo com
                        a regulamentação da autoridade nacional, observados os
                        segredos comercial e industrial;
                        <br />
                        VI. eliminação dos dados pessoais tratados com o
                        consentimento do titular;
                        <br />
                        VII. informação das entidades públicas e privadas com as
                        quais o controlador realizou uso compartilhado de dados;
                        <br />
                        VIII. informação sobre a possibilidade de não fornecer
                        consentimento e sobre as consequências da negativa; e
                        <br />
                        IX. revogação do consentimento.
                        <br />
                        X. revisão de decisões automatizadas.
                    </div>

                    <div>
                        Os titulares dos dados poderão exercer os seus direitos
                        por meio de comunicação escrita enviada para o email:{" "}
                        <strong>
                            administrativo@projectivatecnologia.com.br
                        </strong>
                        , indicando na linha do assunto: “Assunto – Direitos do
                        titular” especificando:
                    </div>

                    <div>
                        Nome completo, número do CPF e endereço de e-mail e, se
                        for o caso, do seu representante;
                    </div>

                    <div>
                        ● Direito que deseja exercer;
                        <br />
                        ● Data do pedido e assinatura do titular;
                        <br />● Todo documento que possa demonstrar ou
                        justificar o exercício de seu direito.
                    </div>

                    <div>
                        Para atender seus direitos, precisamos dos dados acima
                        para confirmar se a pessoa que está exercendo estes
                        direitos é, de fato, você ou pessoa autorizada a agir em
                        seu nome.
                    </div>

                    <div>
                        Note que os direitos não são absolutos e nem sempre se
                        aplicam a todos os casos, mas sempre faremos tudo o que
                        pudermos para honrar estes direitos sob as leis de
                        proteção a dados aplicáveis.
                    </div>

                    <div>7. ALTERAÇÃO/EXCLUSÃO DE DADOS PESSOAIS</div>

                    <div>
                        Você pode optar por não receber mais e-mails da{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        , exceto em relação aos e-mails essenciais para a
                        continuidade da prestação de nossos serviços ou mesmo
                        aqueles que, por obrigação legal ou regulatória, a{" "}
                        <strong>DCEG</strong> necessita enviar a seus usuários.
                    </div>

                    <div>
                        É importante mencionar que, ao preencher qualquer
                        formulário ou realizar qualquer tipo de cadastro,
                        novamente ficará caracterizada a reinserção do seu
                        e-mail à lista de contatos da{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        . Portanto, a requisição de cancelamento deverá ser
                        feita novamente, caso seja de seu interesse.
                    </div>

                    <div>
                        Todos os dados coletados serão excluídos de nossos
                        servidores se você assim requisitar ou quando estes não
                        forem mais necessários ou relevantes para lhe
                        oferecermos Soluções e Serviços, salvo se houver
                        qualquer outra razão para a sua manutenção, como
                        eventual obrigação legal de retenção de dados ou
                        necessidade de preservação destes para resguardo de
                        direitos da{" "}
                        <strong>
                            DCEG Arquitetura e Tecnologia da Informação Ltda
                        </strong>
                        . Para alterar suas informações pessoais ou excluí-las
                        do nosso banco de dados, basta enviar um e-mail para{" "}
                        <strong>
                            administrativo@projectivatecnologia.com.br
                        </strong>{" "}
                        indicando na linha do assunto: “Assunto – Exclusão de
                        Dados”
                    </div>

                    <div>8. ALTERAÇÕES NA POLÍTICA DE PRIVACIDADE</div>

                    <div>
                        Essa Política pode passar por atualizações. Desta forma,
                        recomendamos visitar periodicamente esta página para que
                        você tenha conhecimento sobre as modificações. Caso
                        sejam feitas alterações relevantes que ensejem novas
                        autorizações suas, tornaremos pública a nova política de
                        privacidade.
                    </div>

                    <div>
                        Essa Política foi modificada pela última vez em
                        fevereiro de 2025.
                    </div>

                    <div>9. RECLAMAÇÕES</div>

                    <div>
                        Você também tem o direito de peticionar perante a
                        Autoridade Nacional de Proteção de Dados, que é a
                        responsável por zelar pelo respeito dos direitos dos
                        titulares de dados pessoais no Brasil e fiscalizar o
                        cumprimento da Lei Geral de Proteção de Dados Pessoais
                        (Lei nº 13.709/18 ou LGPD). Acesse em:{" "}
                        <a href="https://www.gov.br/anpd/pt-br" target="_blank" rel="noreferrer">
                            <u>https://www.gov.br/anpd/pt-br</u>.
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
